module.exports = __webpack_public_path__ + "img/ico_roomcharge_default.7f196e5b.png";